export default Object.freeze({
  standardBreak: 'standardBreak',
  standardHours: 'standardHours',
})
